import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  styled,
  TextField,
  Typography,
  FormLabel,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faClose,
  faArrowLeft,
  faCalendarPlus,
  faPaperPlane,
  faClock,
  faCalendarAlt,
  faCircleExclamation,
  faVideo,
  faInfoCircle,
} from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Api from '../../services/api.service'
import { handlingErrors } from '../../utils'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import { format } from 'date-fns'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import 'dayjs/locale/fr'
import 'dayjs/locale/en'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import * as yup from 'yup'
import ButtonRadioInput2 from '../inputs/ButtonRadioInput2'
import { BorderButtonPurple, CustomButton } from '../buttons'
import lightTheme from '../../styles/theme/lightTheme'
import GradientButton from '../buttons/GradientButton'
import OutlineButton from '../buttons/OutlineButton'

const schema = yup.object({})

const BoxContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 500,
  backgroundColor: lightTheme.palette.primary.b6,
  padding: '20px',

  [theme.breakpoints.up('sm')]: {
    /*height: 300,*/
    height: 'auto',
  },
}))

const AppointmentModal = ({ open, onClose, candidate, onSuccess }) => {
  const { t, i18n } = useTranslation()
  const currentUser = useSelector((state) => state.userAuth.user)

  const [step, setStep] = useState(1)
  const [loadingSlots, setLoadingSlots] = useState(false)
  const [loading, setLoading] = useState(false)
  const [slots, setSlots] = useState([])
  const [times, setTimes] = useState('')

  const getDateDisponible = async () => {
    setLoadingSlots(true)
    setTimes('')
    const DateFormat = format(new Date(dateValue), 'yyyy-MM-dd')

    try {
      const result = await Api.calendar.listDIspoEntreprisePerDate(
        DateFormat,
        currentUser.data.id
      )
      const handling = handlingErrors(result)

      if (handling.ok) {
        setSlots(handling.data)
      }
    } catch (error) {
      toast.error(t('successMessage.somethingWrong'))
    }
    setLoadingSlots(false)
  }

  const handleChangeButtonRadio = (inputValue, dateValue) => {
    setTimes(inputValue)
    setCurrentDate(dateValue)
  }

  const onSubmit = async (data) => {
    if (!dateValue || !times) {
      if (!dateValue) setErrorDate(true)
      if (!times) setErrorTime(true)
      return
    }
    setLoading(true)

    const DateValue = format(new Date(dateValue), 'yyyy-MM-dd')
    const appointmentData = {
      dateDebut: `${DateValue}T${times}`,
      dateFin: `${DateValue}T${times}`,
      detail: 'Proposition RDV',
      type: 'rdv_entreprise',
      entreprise: '/api/entreprises/' + currentUser.data.idProfile,
      candidat: '/api/candidats/' + candidate.candidat.id,
    }

    try {
      const result = await Api.calendar.add(appointmentData)
      const res = handlingErrors(result)

      if (res.ok) {
        toast.success(t('successMessage.appointmentRequestSent'))
        setLoading(false)
        onSuccess && onSuccess()
        handleClose()
      }
    } catch (error) {
      toast.error(t('successMessage.somethingWrong'))
    }
  }

  const handleClose = () => {
    setStep(1)
    setDateValue(null)
    setTimes('')
    setSlots([])
    onClose()
  }

  const currentDate = new Date()
  const tomorrowDate = new Date()
  tomorrowDate.setDate(currentDate.getDate() + 1)

  const [currentdate, setCurrentDate] = useState(currentDate)
  const [dateValue, setDateValue] = useState(null)
  const [errorDate, setErrorDate] = useState(false)
  const [errorTime, setErrorTime] = useState(false)

  const { handleSubmit } = useForm({
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (dateValue) {
      getDateDisponible()
    } else {
      setDateValue(dayjs(tomorrowDate))
    }
  }, [dateValue])

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      scroll={'paper'}
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : '16px',
          p: fullScreen ? 0 : '8px',
          m: fullScreen ? 0 : undefined,
          maxHeight: fullScreen ? '100%' : '90vh',
          ...(fullScreen && {
            display: 'flex',
            flexDirection: 'column',
          }),
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 2,
          borderBottom: '1px solid rgba(229, 231, 235, 0.8)',
          backgroundColor: 'rgba(249, 250, 251, 0.5)',
        }}
      >
      <Typography
        variant={fullScreen ? 'subtitle1' : 'h6'}
        sx={{
          fontWeight: 600,
          color: '#1f2937',
          pr: 1,
          lineHeight: 1.3,
          wordBreak: 'break-word',
        }}
      >
          {step === 1
            ? t('box.title.rdvPoroposition')
            : t('box.title.selectTime')}
        </Typography>
        <IconButton
          onClick={handleClose}
          sx={{
            color: '#6b7280',
            '&:hover': {
              backgroundColor: 'rgba(107, 114, 128, 0.1)',
              color: '#374151',
            },
          }}
        >
          <FontAwesomeIcon icon={faClose} />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 2, sm: 3 },
          pt: { xs: '16px !important', sm: '32px !important' },
          flex: fullScreen ? 1 : undefined,
          overflow: 'auto',
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '5px',
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                color: '#374151',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <FontAwesomeIcon
                icon={faCalendarAlt}
                color="#667eea"
                fontSize={14}
              />
              {t(`contact.date`)}
            </Typography>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={i18n.language}
            >
              <DatePicker
                label="Custom input"
                disablePast
                inputFormat={'DD/MM/YYYY'}
                value={dateValue}
                minDate={tomorrowDate}
                onChange={(newValue) => {
                  setDateValue(newValue)
                }}
                renderInput={({ inputRef, inputProps, InputProps }) => (
                  <>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        height: '48px',
                        borderRadius: '12px',
                        border: '2px solid #e5e7eb',
                        backgroundColor: '#ffffff',
                        transition: 'all 0.3s ease',
                        position: 'relative',
                        overflow: 'hidden',
                        '&:hover': {
                          borderColor: '#667eea',
                          boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)',
                        },
                        '&:focus-within': {
                          borderColor: '#667eea',
                          boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.2)',
                        },

                        '& .css-1laqsz7-MuiInputAdornment-root, & .MuiInputAdornment-root':
                          {
                            height: '100%',
                            width: '48px',
                            margin: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor:
                              'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            borderRadius: '0 10px 10px 0',

                            '& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root, & .-root-MuiIconButton-root, .MuiIconButton-root':
                              {
                                margin: 0,
                                color: '#FFFFFF !important',
                                '&:hover': {
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                },
                                '& svg': {
                                  color: '#9a9b9e !important',
                                },
                              },
                          },
                      }}
                    >
                      <input
                        ref={inputRef}
                        {...inputProps}
                        style={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '10px 0 0 10px',
                          border: 'none',
                          padding: '12px 16px',
                          fontFamily: 'Century Gothic',
                          fontSize: 14,
                          lineHeight: '140%',
                          letterSpacing: '0.2px',
                          color: lightTheme.palette.text.primary,
                          backgroundColor: 'transparent',
                          outline: 'none',
                        }}
                      />
                      {InputProps?.endAdornment}
                    </Box>
                    <Box
                      className="date-input-overlay"
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background:
                          'linear-gradient(90deg, transparent 0%, rgba(102, 126, 234, 0.05) 100%)',
                        borderRadius: '12px',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',
                        pointerEvents: 'none',
                        '&:hover': {
                          opacity: 1,
                        },
                      }}
                    />
                  </>
                )}
              />
            </LocalizationProvider>
            {errorDate && (
              <Typography
                className={'error-message'}
                sx={{
                  color: '#ef4444',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <FontAwesomeIcon icon={faCircleExclamation} fontSize={12} />
                {t('errorMessage.date')}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: '5px',
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                color: '#374151',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}
            >
              <FontAwesomeIcon icon={faClock} color="#667eea" fontSize={14} />
              {t(`contact.slots`)}
            </Typography>
            {loadingSlots ? (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: 200,
                  backgroundColor: '#f9fafb',
                  borderRadius: '12px',
                  border: '2px dashed #e5e7eb',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                  }}
                >
                  <CircularProgress
                    size={32}
                    sx={{
                      color: '#667eea',
                      '& .MuiCircularProgress-circle': {
                        strokeLinecap: 'round',
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      color: '#6b7280',
                      fontSize: '12px',
                      fontWeight: 500,
                    }}
                  >
                    {t('home.slots')}
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  minHeight: 240,
                  overflowY: 'auto',
                  padding: 1,
                  backgroundColor: '#f9fafb',
                  borderRadius: '12px',
                  border: '1px solid #e5e7eb',

                  '&::-webkit-scrollbar': {
                    width: 6,
                  },

                  '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                  },

                  '&::-webkit-scrollbar-thumb': {
                    background: '#d1d5db',
                    borderRadius: 3,
                  },

                  '&::-webkit-scrollbar-thumb:hover': {
                    background: '#9ca3af',
                  },
                }}
              >
                {Object.entries(slots).map(([date, slotTimes]) => (
                  <Box
                    key={date}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: 600,
                        color: '#6b7280',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        px: 1,
                        py: 0.5,
                        backgroundColor: '#e5e7eb',
                        borderRadius: '6px',
                        textAlign: 'center',
                      }}
                    >
                      {date}
                    </Typography>
                    {slotTimes.length > 0 ? (
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          justifyContent: {xs: 'center', sm: 'flex-start'},
                          alignItems: {xs: 'center', sm: 'flex-start'},
                          gap: 1,
                          px: 1,
                        }}
                      >
                        {slotTimes.map((time, index) => {
                          const isSelected =
                            times === time && date === currentdate
                          return (
                            <Button
                              key={index}
                              onClick={() => {
                                handleChangeButtonRadio(time, date)
                              }}
                              sx={{
                                minWidth: 'auto',
                                px: 2,
                                py: 1,
                                fontSize: '12px',
                                fontWeight: 500,
                                borderRadius: '8px',
                                border: '2px solid',
                                borderColor: isSelected ? '#667eea' : '#e5e7eb',
                                backgroundColor: isSelected
                                  ? '#667eea'
                                  : '#ffffff',
                                color: isSelected ? '#ffffff' : '#374151',
                                transition: 'all 0.2s ease',
                                textTransform: 'none',
                                boxShadow: isSelected
                                  ? '0 2px 4px rgba(102, 126, 234, 0.3)'
                                  : '0 1px 2px rgba(0, 0, 0, 0.05)',
                                '&:hover': {
                                  backgroundColor: isSelected
                                    ? '#5a67d8'
                                    : '#f9fafb',
                                  borderColor: isSelected
                                    ? '#5a67d8'
                                    : '#667eea',
                                  transform: 'translateY(-1px)',
                                  boxShadow: isSelected
                                    ? '0 4px 6px rgba(102, 126, 234, 0.4)'
                                    : '0 2px 4px rgba(0, 0, 0, 0.1)',
                                },
                              }}
                            >
                              {time}
                            </Button>
                          )
                        })}
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          px: 1,
                          py: 2,
                          textAlign: 'center',
                          backgroundColor: '#ffffff',
                          borderRadius: '8px',
                          border: '1px dashed #d1d5db',
                        }}
                      >
                        <Typography
                          sx={{
                            color: '#9ca3af',
                            fontSize: '12px',
                            fontStyle: 'italic',
                          }}
                        >
                          {t('slots.noAvailable')}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            )}
            {errorTime && (
              <Typography
                className={'error-message'}
                sx={{
                  color: '#ef4444',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <FontAwesomeIcon icon={faCircleExclamation} fontSize={12} />
                {t('errorMessage.timeSlot')}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
          >
            {/* <Typography
                  sx={{
                    fontWeight: 600,
                    color: '#374151',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <FontAwesomeIcon
                    icon={faVideo}
                    color="#667eea"
                    fontSize={14}
                  />
                  {t('box.videoconferenceLink')}
                </Typography> */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 2,
                backgroundColor: '#f0f9ff',
                borderRadius: '12px',
                border: '1px solid #bae6fd',
              }}
            >
              <FontAwesomeIcon icon={faVideo} color="#0ea5e9" fontSize={16} />
              <Typography
                sx={{
                  fontSize: '12px',
                  color: '#0c4a6e',
                  lineHeight: 1.5,
                }}
              >
                {t('videoconference.autoGenerated')}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 2, sm: 3 },
          gap: 2,
          justifyContent: 'center',
          backgroundColor: 'rgba(249, 250, 251, 0.8)',
          borderTop: '1px solid rgba(229, 231, 235, 0.8)',
          flexDirection: { xs: 'column', sm: 'row' },
          flexShrink: 0,
          '& > *': {
            width: { xs: '100%', sm: 'auto' },
            m: 0,
          },
        }}
      >
        <OutlineButton onClick={handleClose} fullWidth={fullScreen}>
          {t('button.cancel')}
        </OutlineButton>

        <GradientButton
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          disabled={!dateValue || !times}
          fullWidth={fullScreen}
        >
          {loading ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <>
              <FontAwesomeIcon
                icon={faCalendarPlus}
                style={{ marginRight: '8px', fontSize: '14px' }}
              />
              {t('button.rdvSuggest')}
            </>
          )}
        </GradientButton>
      </DialogActions>
    </Dialog>
  )
}

export default AppointmentModal
